const TAB_MAP: Record<string, string> = {
  summary: "overview",
  enrollment: "subjects",
  safety: "adverse-events",
  "protocol-deviations": "protocol-deviations",
  "data-quality": "crf-completion",
  risk: "risk",
};

export function buildTrialSiteUrl(
  trialId: string,
  siteId: string,
  crossTrialTab: string,
): string {
  const singleSiteTab = TAB_MAP[crossTrialTab] ?? "overview";
  return `/trial/${trialId}/sites/profile/${siteId}/${singleSiteTab}`;
}
